import emailjs from 'emailjs-com';

// 🔧 CONFIGURAZIONE EMAILJS CORRETTA
const EMAIL_CONFIG = {
  serviceId: 'service_mnni26u',
  templateId: 'template_07hbw8o', 
  userId: 'o4948ePmzfz0VRfRy',
};

// 🚨 VERIFICA SE EMAILJS È CONFIGURATO
const isEmailJSConfigured = () => {
  return EMAIL_CONFIG.templateId !== 'template_contact_form' && 
         EMAIL_CONFIG.userId !== 'user_emailjs_2025';
};

// 🔄 INIZIALIZZA EMAILJS
try {
  if (typeof window !== 'undefined') {
    emailjs.init(EMAIL_CONFIG.userId);
    console.log('✅ EmailJS inizializzato con User ID:', EMAIL_CONFIG.userId);
  }
} catch (error) {
  console.warn('⚠️ Errore inizializzazione EmailJS:', error);
}

// 🌐 CONTROLLO AMBIENTE NETLIFY
const isNetlifyEnvironment = () => {
  return typeof window !== 'undefined' && (
    window.location.hostname.includes('.netlify.app') ||
    window.location.hostname.includes('netlify.com') ||
    process.env.NODE_ENV === 'production'
  );
};

export const sendContactEmail = async (formData) => {
  console.log('📧 Tentativo invio email per:', formData.nome);
  console.log('🌐 Ambiente:', isNetlifyEnvironment() ? 'Netlify' : 'Locale');

  try {
    // Salva nel localStorage per sicurezza
    try {
      const existingRequests = JSON.parse(localStorage.getItem('contact_requests') || '[]');
      const timestamp = new Date().toISOString();
      const newRequest = {
        ...formData,
        timestamp,
        status: 'received',
        id: Date.now(),
        method: 'emailjs_system',
        environment: isNetlifyEnvironment() ? 'netlify' : 'local'
      };
      
      existingRequests.push(newRequest);
      localStorage.setItem('contact_requests', JSON.stringify(existingRequests));
      console.log('💾 Richiesta salvata con successo:', newRequest);
    } catch (e) {
      console.warn('⚠️ Errore salvataggio localStorage:', e);
    }

    // 🎯 INVIO PRINCIPALE CON EMAILJS
    if (isEmailJSConfigured() && typeof emailjs !== 'undefined') {
      console.log('📧 Invio via EmailJS con configurazione completa...');
      
      const templateParams = {
        from_name: formData.nome,
        from_email: formData.email,
        phone: formData.telefono || 'Non fornito',
        service: formData.servizio,
        budget: formData.budget || 'Da valutare',
        message: formData.messaggio || 'Nessun messaggio aggiuntivo',
        to_email: 'info@realizzazionesitiwebnapoli.com',
        reply_to: formData.email,
        date: new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' }),
        source: isNetlifyEnvironment() ? 'Netlify App' : 'Sito Web'
      };

      console.log('📋 Parametri template:', templateParams);

      const response = await emailjs.send(
        EMAIL_CONFIG.serviceId,
        EMAIL_CONFIG.templateId,
        templateParams,
        EMAIL_CONFIG.userId
      );

      if (response.status === 200) {
        console.log('✅ Email inviata con successo via EmailJS!', response);
        
        // Aggiorna localStorage con successo
        try {
          const requests = JSON.parse(localStorage.getItem('contact_requests') || '[]');
          const lastRequest = requests[requests.length - 1];
          if (lastRequest) {
            lastRequest.emailjs_status = 'sent_success';
            lastRequest.emailjs_response = response.status;
            localStorage.setItem('contact_requests', JSON.stringify(requests));
          }
        } catch (e) {
          console.warn('Errore aggiornamento localStorage:', e);
        }

        // 🎉 MESSAGGIO DI SUCCESSO REALE
        const successMessage = 
          `✅ RICHIESTA INVIATA CON SUCCESSO!\n\n` +
          `Ciao ${formData.nome}! 👋\n\n` +
          `La tua richiesta per "${formData.servizio}" è stata inviata correttamente a info@realizzazionesitiwebnapoli.com\n\n` +
          `📧 Ti risponderemo entro 24 ore con un preventivo personalizzato!\n\n` +
          `📞 Per urgenze: +39 350 070 3118\n` +
          `💬 WhatsApp: +39 350 070 3118\n\n` +
          `Grazie per averci contattato!`;

        alert(successMessage);

        return {
          success: true,
          message: `Email inviata con successo! Ti risponderemo entro 24 ore.`,
          method: 'emailjs_direct',
          timestamp: new Date().toISOString(),
          environment: isNetlifyEnvironment() ? 'netlify' : 'local',
          emailjs_response: response.status
        };

      } else {
        throw new Error(`EmailJS response status: ${response.status}`);
      }

    } else {
      console.warn('⚠️ EmailJS non configurato - usando sistema fallback');
      
      // 🚨 FALLBACK: Crea WhatsApp e Email pre-compilati
      const whatsappMessage = encodeURIComponent(
        `🚀 NUOVA RICHIESTA DAL SITO\n\n` +
        `👤 CLIENTE:\n` +
        `Nome: ${formData.nome}\n` +
        `Email: ${formData.email}\n` +
        `Telefono: ${formData.telefono || 'Non fornito'}\n\n` +
        `🛠️ RICHIESTA:\n` +
        `Servizio: ${formData.servizio}\n` +
        `Budget: ${formData.budget || 'Da valutare'}\n\n` +
        `💬 MESSAGGIO:\n` +
        `${formData.messaggio || 'Nessun messaggio aggiuntivo'}\n\n` +
        `📅 Data: ${new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}\n\n` +
        `⚡ RISPONDERE ENTRO 24 ORE!`
      );

      const emailSubject = encodeURIComponent(`🚀 RICHIESTA DAL SITO - ${formData.nome}`);
      const emailBody = encodeURIComponent(
        `NUOVA RICHIESTA DAL SITO WEB\n\n` +
        `👤 DATI CLIENTE:\n` +
        `Nome: ${formData.nome}\n` +
        `Email: ${formData.email}\n` +
        `Telefono: ${formData.telefono || 'Non fornito'}\n\n` +
        `🛠️ DETTAGLI RICHIESTA:\n` +
        `Servizio: ${formData.servizio}\n` +
        `Budget: ${formData.budget || 'Da valutare'}\n\n` +
        `💬 MESSAGGIO:\n` +
        `"${formData.messaggio || 'Nessun messaggio aggiuntivo'}"\n\n` +
        `📅 INFORMAZIONI:\n` +
        `Data: ${new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}\n` +
        `Fonte: ${isNetlifyEnvironment() ? 'Netlify App' : 'Sito Web'}\n\n` +
        `--- Messaggio automatico ---`
      );

      const whatsappUrl = `https://wa.me/393500703118?text=${whatsappMessage}`;
      const emailUrl = `mailto:info@realizzazionesitiwebnapoli.com?subject=${emailSubject}&body=${emailBody}`;

      const userChoice = confirm(
        `⚠️ SISTEMA DI BACKUP ATTIVO\n\n` +
        `Ciao ${formData.nome}, la richiesta è stata salvata.\n\n` +
        `Per inviarla immediatamente:\n\n` +
        `✅ OK = WhatsApp (Consigliato)\n` +
        `❌ Annulla = Email\n\n` +
        `Ti contatteremo entro 24 ore!`
      );

      if (userChoice) {
        window.open(whatsappUrl, '_blank');
      } else {
        window.open(emailUrl, '_blank');
      }

      return {
        success: true,
        message: 'Richiesta elaborata con sistema di backup.',
        method: userChoice ? 'whatsapp_fallback' : 'email_fallback',
        environment: isNetlifyEnvironment() ? 'netlify' : 'local'
      };
    }

  } catch (error) {
    console.error('❌ Errore sistema completo:', error);
    
    // 🚨 FALLBACK DI EMERGENZA
    const emergencyWhatsApp = `https://wa.me/393500703118?text=${encodeURIComponent(
      `EMERGENZA - Richiesta da ${formData.nome} (${formData.email}). ` +
      `Servizio: ${formData.servizio}. ` +
      `Budget: ${formData.budget || 'Da valutare'}. ` +
      `Messaggio: ${formData.messaggio || 'Nessuno'}`
    )}`;
    
    const emergencyChoice = confirm(
      `🚨 ERRORE TECNICO\n\n` +
      `Ciao ${formData.nome}, problema temporaneo.\n\n` +
      `SOLUZIONI IMMEDIATE:\n\n` +
      `✅ OK = WhatsApp diretto\n` +
      `❌ Annulla = Riprova tra 5 minuti\n\n` +
      `I tuoi dati sono stati salvati!`
    );
    
    if (emergencyChoice) {
      window.open(emergencyWhatsApp, '_blank');
      
      setTimeout(() => {
        alert(
          `📱 WHATSAPP APERTO!\n\n` +
          `Il messaggio è pronto con i tuoi dati.\n\n` +
          `✅ Premi INVIO per inviare\n` +
          `📞 Risposta garantita entro 1 ora!`
        );
      }, 1000);
    }
    
    return {
      success: false,
      message: 'Errore temporaneo. Riprova o contattaci direttamente.',
      method: 'emergency_fallback',
      error: error.message
    };
  }
};

// Resto delle funzioni rimane uguale...
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  if (!phone) return true;
  const phoneRegex = /^(\+39|0039|39)?[\s]?([0-9]{2,4}[\s]?[0-9]{6,8})$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

export const getSavedRequests = () => {
  try {
    return JSON.parse(localStorage.getItem('contact_requests') || '[]');
  } catch (e) {
    return [];
  }
};

export const clearSavedRequests = () => {
  try {
    localStorage.removeItem('contact_requests');
    console.log('🧹 Richieste salvate eliminate');
  } catch (e) {
    console.warn('⚠️ Errore eliminazione richieste:', e);
  }
};

export const getEmailJSConfig = () => {
  return {
    isConfigured: isEmailJSConfigured(),
    serviceId: EMAIL_CONFIG.serviceId,
    templateId: EMAIL_CONFIG.templateId,
    userId: EMAIL_CONFIG.userId,
    environment: isNetlifyEnvironment() ? 'netlify' : 'local',
    status: isEmailJSConfigured() ? '✅ CONFIGURATO E ATTIVO' : '❌ NON CONFIGURATO'
  };
};

export const testEmailJSConnection = async () => {
  console.log('🧪 Test connessione EmailJS...');
  
  if (!isEmailJSConfigured()) {
    return {
      success: false,
      message: '❌ EmailJS NON configurato',
      details: 'Mancano Template ID o User ID validi',
      config: EMAIL_CONFIG
    };
  }

  const testData = {
    nome: 'Test Sistema EmailJS',
    email: 'test@emailjs.com',
    telefono: '123456789',
    servizio: 'Test Connessione',
    budget: 'Test Budget',
    messaggio: 'Test di connessione EmailJS - Ignorare questo messaggio'
  };

  try {
    const result = await sendContactEmail(testData);
    
    return {
      success: true,
      message: '✅ Test EmailJS riuscito!',
      details: {
        method: result.method,
        environment: result.environment,
        emailjs_response: result.emailjs_response,
        timestamp: result.timestamp
      },
      config: EMAIL_CONFIG
    };
  } catch (error) {
    return {
      success: false,
      message: '❌ Test EmailJS fallito: ' + error.message,
      error: error,
      config: EMAIL_CONFIG
    };
  }
};

export const openWhatsAppDirect = (nome, email, servizio) => {
  const message = encodeURIComponent(
    `Ciao! Sono ${nome || 'un potenziale cliente'}.\n` +
    `Email: ${email || 'non fornita'}\n` +
    `Interessato a: ${servizio || 'i vostri servizi'}\n` +
    `Fonte: ${isNetlifyEnvironment() ? 'Netlify App' : 'Sito Web'}\n\n` +
    `Vorrei maggiori informazioni. Grazie!`
  );
  
  const url = `https://wa.me/393500703118?text=${message}`;
  window.open(url, '_blank');
  
  return url;
};

export const openEmailDirect = (nome, email, servizio) => {
  const subject = encodeURIComponent(`Richiesta ${isNetlifyEnvironment() ? 'Netlify' : 'Web'} - ${nome || 'Cliente'}`);
  const body = encodeURIComponent(
    `Buongiorno,\n\n` +
    `sono ${nome || 'interessato ai vostri servizi'}.\n` +
    `La mia email è: ${email || 'da fornire'}\n\n` +
    `Vorrei informazioni su: ${servizio || 'i vostri servizi'}\n\n` +
    `Fonte: ${isNetlifyEnvironment() ? 'Netlify App' : 'Sito Web'}\n\n` +
    `Potete contattarmi per un preventivo?\n\n` +
    `Grazie,\n${nome || 'Cordiali saluti'}`
  );
  
  const url = `mailto:info@realizzazionesitiwebnapoli.com?subject=${subject}&body=${body}`;
  window.open(url);
  
  return url;
};